import BackgroundSection from "@/components/BackgroundSection/BackgroundSection";
import Box from "@/components/Box";
import SectionSliderNewCategories from "@/components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "@/components/SectionSubscribe2/SectionSubscribe2";
import StepIndicator from "@/components/StepIndicator/StepIndicator";
import { BookingStatus, PaymentStatus } from "@/generated/zeus";
// import useUserContext from "@/hooks/useUserContext";
import { mutation } from "@/hooks/useZeus";
import StatusBadge from "@/shared/Badge/StatusBadge";
import ButtonSecondary from "@/shared/Button/ButtonSecondary";
import Loader from "@/shared/FullScreenLoader/Loading";
import moment from "moment";
import { FC, useState } from "react";
import { toast } from "react-toastify";
import MediaLibraryPicker from "../MediaAssetsPage/MediaLibraryPicker";
import BookingChangelog from "./BookingChangelog";
import { useBookingDetails } from "./useBookingDetails";
import { GST } from "@/contains/contants";
import { Dialog } from "@/components/Dialog/Dialog";
import PaymentDialog from "./PaymentDialog";
import { PriceSummary } from "./PriceSummary";
import { AddReviewDialog } from "./AddReviewDialog";
import { Button } from "@/components/ui/button";
import ContactUs from "../PageContact/ContactUs";
import { Table, TableHeader,TableBody, TableCell, TableHead, TableRow  } from "@/components/ui/table";
import { getDateTimeString } from "@/lib/utils";
import { useUser } from '@stackframe/react';
import ButtonPrimary from "@/shared/Button/ButtonPrimary";

export interface ListingCarDetailPageProps {
  className?: string;
}

export function BookingDetails() {

  return <>
    <ListingCarDetailPage />
  </>
}

const ListingCarDetailPage: FC<ListingCarDetailPageProps> = ({
  className = "",
}) => {
  const { bookingDetails, loading, refetch } = useBookingDetails();
  const booking = bookingDetails?.booking;
  const priceSummary = booking?.priceSummary;
  const { adBoard, payment, selectedDates } = bookingDetails?.booking || {}
  const [bookingUpdateCounter, setBookingUpdateCounter] = useState(0);
  useUser({or:'redirect'})

  const renderAdboardDetails = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}

        {/* 2 */}
        <a target="_blank" href={"/hoardings/"+adBoard?.title+"/" + adBoard?.id+window.location.search}>
          <h2 className="text-xl sm:text-xl lg:text-2xl font-semibold">
            {adBoard?.title}
          </h2>
          <img src={adBoard?.featuredImage} className="w-full aspect-square object-cover rounded-lg mt-2"/>
        </a>

        {/* 3 */}
        <div className="flex items-center space-x-4">
          {/* <StartRating /> */}
          {/* <span>·</span> */}
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1"> {adBoard?.city}</span>
          </span>
        </div>

        {/* 5 */}
 
      </div>
    );
  };

  const renderAssetDetails = () => {
    return (
      <div className="listingSection__wrap mt-4 lg:mt-0">
        {/* PRICE */}
        <div className="flex justify-between items-center">
          <span className="text-2xl font-semibold">
            Asset details
          </span>
          <div>
            <MediaLibraryPicker onCardSelect={handleFileSelect}>
              <ButtonPrimary className=''>Update asset</ButtonPrimary>
            </MediaLibraryPicker>
          </div>
        </div>
        <div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Version</TableHead>
                <TableHead></TableHead>
                <TableHead>Approval status</TableHead>
                <TableHead>Submitted at</TableHead>
                <TableHead>Approved at</TableHead>
                {/* <TableHead>Deployed at</TableHead> */}
              </TableRow>
            </TableHeader>
            <TableBody>
              {booking?.contentVersions.map((item,i)=>{
                return <TableRow key={i}>
                  <TableCell>{item.versionNumber} &nbsp;
                    {booking.currentDeployedVersionId == item.id && <StatusBadge>Deployed</StatusBadge>}
                  </TableCell>
                  <TableCell>
                    {item.assets.length ==1 ? <>
                      <img className="h-16 w-16 rounded-lg" src={item.assets[0].url} alt="image description" />
                    </>:<>
                      <Dialog header={'Asset preview'}>
                        <Dialog.Trigger>
                          <ButtonSecondary>View</ ButtonSecondary>
                        </Dialog.Trigger>
                        <Dialog.Body>
                          <div>
                            {item.assets.map(item=>{
                              return <img key={item.url} className="Sirv h-auto w-full rounded-lg" src={item.url} alt="image description" />
                            })}
                          </div>
                        </Dialog.Body>
                      </Dialog>
                    </>}
                  </TableCell>
                  <TableCell>{item.status}</TableCell>
                  <TableCell>{getDateTimeString(item.submittedAt)}</TableCell>
                  <TableCell>{getDateTimeString(item.approvedAt)}</TableCell>
                  {/* <TableCell>{getDateTimeString(item.deployedAt)}</TableCell> */}
                
                </TableRow>
              })}
             
            </TableBody>
          </Table>
        </div>
      </div>
    )
  }

  const proofsSection = () => {
    if (!bookingDetails?.booking?.proofs?.length) {
      return
    }
    return (
      <Box title="Proofs">
        <div className="Sirv">
          {bookingDetails?.booking?.proofs?.map((item) => (
            <div data-src={item.url}></div>
          ))}
        </div> 
      </Box>
    );
  };

  const renderHistory = () => {
    return (
      <Box title="Change history" collapsible collapsed>
        
        <div className="relative overflow-x-auto mt-4">
          {booking?.id && <BookingChangelog counter={bookingUpdateCounter} bookingId={booking?.id} />}
        </div>

      </Box>
    );
  };

  const renderPaymentDetails = () => {
    return (
      <div className="listingSection__wrap mt-4 lg:mt-0">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-2xl font-semibold">
            Payment details
          </span>

        </div>

        {booking?.payment ?
       
          <div className="flex flex-col space-y-4 ">
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Subtotal</span>
              <span>{payment?.totalDetails?.subtotal}</span>
            </div>
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>GST({GST})</span>
              <span>{payment?.totalDetails?.tax}</span>
            </div>
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Discount</span>
              <span>{payment?.totalDetails?.discount}</span>
            </div>

            <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="flex justify-between font-semibold">
              <span>Total</span>
              <span>{payment?.totalDetails?.total}</span>
            </div>
          </div>
          : <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
      
            <span>Payment not done yet</span>
            <span>₹0</span>
          </div>}

      </div>
    );
  };

  // async function triggerMail(){
  //   if(booking?.id){
  //     await mutation({
  //       sendMail:[{
  //         bookingId:booking?.id,
  //         templateId:TemplateIds.ASSET_UPDATED,
  //         to:[]
  //       },{
  //         success:true
  //       }]
  //     })
  //   }
  // }

  async function handleFileSelect(file: { id: string, name: string, url: string }) {

    if (!file.id) {
      toast.error('File url is not present.');
      return;
    }

    if (moment(booking?.selectedDates.endDate).isBefore(moment(), 'date')) {
      toast.error('Booking has already ended.');
      return;
    }

    const answer = confirm("Are you sure you want to change the asset? (Y/N)")

    if (answer && booking?.id) {

      const toastId = toast.info('Updating asset and changing booking status to pending approval.',{
        isLoading:true,
      });

      await mutation({
        updateBookingAssets:[{
          assetIds: [file.id],
          bookingId: booking?.id,
        },{
          id:true,
        }]
      })

      setBookingUpdateCounter(bookingUpdateCounter + 1);
      toast.dismiss(toastId);
      refetch();

      // triggerMail()
    }
  }

  const renderSidebarDetail = () => {
    return (
      <div className="listingSection__wrap">
        <div className="flex justify-between items-center">
          <span className="text-2xl font-semibold block mt-4 lg:mt-0">
            Booking details
          </span>
        </div>

        <div className="flex flex-col space-y-4 ">
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Booked on</span>
            <span>{moment(booking?.bookingDate).format('LLL')}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Booking start date</span>
            <span>{moment(selectedDates?.startDate as string).format('DD MMM YYYY')}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Booking end date</span>
            <span>{moment(selectedDates?.endDate).format('DD MMM YYYY')}</span>
          </div>

          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Booking code</span>
            <span>{booking?.bookingCode}</span>
          </div>
        </div>
      </div>
    );
  };
  
  if (loading || loading == undefined) {
    return <Loader fullScreen>
      <div>Fetching booking...</div>
    </Loader>
  }

  if (!loading && !booking?.id) {
    return <div className="container mt-8">
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold pb-40">
        Booking not found
      </h1>
    </div>
  }

  return (
    <div
      className={`ListingDetailPage nc-ListingCarDetailPage ${className}`}
      data-nc-id="ListingCarDetailPage"
    >

      <div className="container mt-8">
        <div className="listingSection__wrap mt-8 lg:shadow-md">
          <StepIndicator booking={booking} />
        </div>
        {booking?.bookingStatus == BookingStatus.APPROVED && booking.paymentStatus!= PaymentStatus.PAID && 
        <div className="p-4 flex mt-6 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
          <div className="flex justify-between w-full items-center">
            <span>
              <span className="font-medium">Congratulations!</span> Your booking has been approved, Please proceed for payment.
            </span>
            <Dialog header="Confirm payment">
              <Dialog.Trigger>
                <ButtonSecondary className="">Proceed to payment</ButtonSecondary>
              </Dialog.Trigger>
              <Dialog.Body>
                <PaymentDialog bookingId={booking.id} priceSummary={{
                  pricePerDay: priceSummary?.rentPerDay||0,
                  days: priceSummary?.days||0,
                  totalRent: priceSummary?.totalRent||0,
                  subtotal: priceSummary?.subtotal||0,
                  gst: priceSummary?.serviceCharge||0,
                }}/>
              </Dialog.Body>
            </Dialog>
          </div>
        </div>
        }
      </div>

      <main className="container relative z-10 mt-6 grid lg:grid-cols-10 gap-8">
        <div className="col-span-7 flex flex-col gap-8">
          {/* {renderDeployedAsset()} */}
          
          {renderSidebarDetail()}
          {/* <Box title="Price summary"> */}
          <PriceSummary priceSummary={{
            pricePerDay: priceSummary?.rentPerDay||0,
            days: priceSummary?.days||0,
            totalRent: priceSummary?.totalRent||0,
            subtotal: priceSummary?.subtotal||0,
            gst: priceSummary?.serviceCharge||0,
          }} />
          {/* </Box> */}
          
          {renderPaymentDetails()}
         
          {renderAssetDetails()}
          {proofsSection()}
          {renderHistory()}

        </div>
        <div className="col-span-3">
          <div className="hidden lg:flex gap-4 flex-col sticky top-28">
            {renderAdboardDetails()}
            <div className="mt-4 space-y-2 flex flex-col">
              <Dialog header="Add review"> 
                <Dialog.Trigger>
                  <Button className='w-full'>Leave a review</Button>
                </Dialog.Trigger>
                <Dialog.Body>
                  <AddReviewDialog adBoardId = {booking?.adBoard.id as string} bookingId={booking?.id as string} />
                </Dialog.Body>
              </Dialog>

              <Dialog header="Need help with booking"> 
                <Dialog.Trigger>
                  <Button className='w-full'>Need help with booking</Button>
                </Dialog.Trigger>
                <Dialog.Body>
                  <div className="pb-1">
                    <ContactUs defaultMessage={"I need help with my booking #"+booking?.id}/>
                  </div>
                </Dialog.Body>
              </Dialog>
            </div>
          </div>

        </div>
      </main>

      {/* STICKY FOOTER MOBILE */}
      {/* <MobileFooterSticky sta/> */}

      {/* OTHER SECTION */}
      <div className="container py-24 lg:py-32">
        {/* SECTION 1 */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSliderNewCategories
            heading="Explore by types of adboards"
            subHeading="Explore adboards based on 10 types of signages"
            categoryCardType="card5"
            itemPerRow={5}
            sliderStyle="style2"
            uniqueClassName="ListingCarDetailPage"
          />
        </div>

        {/* SECTION */}
        <SectionSubscribe2 className="pt-24 lg:pt-32" />
      </div>
    </div>
  );
};

export default ListingCarDetailPage;
